import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { toasterMessages } from '@messages/*';
import { ToastrService } from 'ngx-toastr';
import { LoginRegisterService } from '../login-register.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ForgotpasswordComponent implements OnInit, AfterViewInit, OnDestroy {

  isDisabledBtn: boolean = false;
  submitting: boolean = false;
  showInlineSuccess: boolean = false;
  inlineMessage: string = '';
  cooldownRemaining: number = 0;
  private cooldownTimer: any;

  @ViewChild('emailInput') emailInput?: ElementRef<HTMLInputElement>;

  forgotPasswordForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]]
  });

  constructor(
    private loginRegisterService: LoginRegisterService,
    private toastr: ToastrService,
    private fb: FormBuilder
  ) { }

  ngOnInit() { }

  ngAfterViewInit(): void {
    setTimeout(() => this.emailInput?.nativeElement?.focus(), 0);
  }

  forgotPwdSumbit() {
    if (this.forgotPasswordForm.invalid || this.submitting || this.cooldownRemaining > 0) {
      return;
    }

    const email = this.forgotPasswordForm.get('email').value?.trim()?.toLowerCase();
    this.submitting = true;
    this.isDisabledBtn = true;
    this.showInlineSuccess = false;

    // Skip global overlay loader; use inline button spinner instead
    const options = { headers: { 'skip-loader': 'true' } };
    this.loginRegisterService.forgotPassword({ email }, options).subscribe(() => {
      // Generic success toast + inline message
      this.toastr.success(toasterMessages.resetLinkSent);
      this.inlineMessage = `If ${email} is registered, we\u2019ve sent a reset link. Check your inbox and spam.`;
      this.showInlineSuccess = true;
      this.startCooldown();
    }, (err) => {
      // Show the same inline message for consistency
      this.inlineMessage = `If ${email} is registered, we\u2019ve sent a reset link. Check your inbox and spam.`;
      this.showInlineSuccess = true;
      this.startCooldown();
    }, () => {
      this.submitting = false;
    });
  }

  private startCooldown(): void {
    this.clearCooldown();
    this.cooldownRemaining = 30;
    this.cooldownTimer = setInterval(() => {
      this.cooldownRemaining = Math.max(0, this.cooldownRemaining - 1);
      if (this.cooldownRemaining === 0) {
        this.clearCooldown();
        this.isDisabledBtn = false;
      }
    }, 1000);
  }

  private clearCooldown(): void {
    if (this.cooldownTimer) {
      clearInterval(this.cooldownTimer);
      this.cooldownTimer = null;
    }
  }

  ngOnDestroy(): void {
    this.clearCooldown();
  }

}
